import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import * as FilialActions from '@app/shared/store/actions';

import { FilialService } from '@app/shared/services';

@Injectable()
export class FilialEffects {
  getFilials$ = createEffect(() =>
    this.actions$.pipe(
      ofType<FilialActions.GetFilials>(
        FilialActions.FilialsActionTypes.GET_FILIALS
      ),
      switchMap((action) => {
        return this._FilialService.getFilials().pipe(
          map((resp) => {
            return new FilialActions.GetFilialsSuccess(resp);
          }),
          catchError((error) => {
            return of(new FilialActions.GetFilialsError(error));
          })
        );
      })
    )
  );

  getFilialByCity$ = createEffect(() =>
    this.actions$.pipe(
      ofType<FilialActions.GetFilialsbyCity>(
        FilialActions.FilialsActionTypes.GET_FILIAL_BY_CITY
      ),
      switchMap((action) => {
        return this._FilialService.getFilialByCity(action.payload).pipe(
          map((resp) => {
            return new FilialActions.GetFilialsbyCitySuccess(resp);
          }),
          catchError((error) => {
            return of(new FilialActions.GetFilialsbyCityError(error));
          })
        );
      })
    )
  );

  getFilialByManager$ = createEffect(() =>
    this.actions$.pipe(
      ofType<FilialActions.GetFilialbyManager>(
        FilialActions.FilialsActionTypes.GET_FILIAL_BY_MANAGER
      ),
      switchMap((action) => {
        return this._FilialService.getFilialByManager(action.manager_id).pipe(
          map((resp) => {
            return new FilialActions.GetFilialbyManagerSuccess([resp]);
          }),
          catchError((error) => {
            return of(new FilialActions.GetFilialbyManagerError(error));
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _FilialService: FilialService
  ) {}
}
